export enum KeyboardKeys {
    ENTER = 'Enter'
}